const buildKey = (sourceName?: string): string => `i2a-onboarding-skipped-${sourceName || 'global'}`;

export const isOnboardingSkipped = (sourceName?: string): boolean => {
  try {
    return localStorage.getItem(buildKey(sourceName)) === 'true';
  } catch {
    return false;
  }
};

export const markOnboardingSkipped = (sourceName?: string): void => {
  try {
    localStorage.setItem(buildKey(sourceName), 'true');
  } catch {
    // localStorage unavailable
  }
};

export const clearOnboardingSkipped = (sourceName?: string): void => {
  try {
    localStorage.removeItem(buildKey(sourceName));
  } catch {
    // localStorage unavailable
  }
};
